export function handleScroll () {
    const header = document.querySelector('.header');
    const body = document.querySelector('body');

    function updateHeaderClass () {
        const scrollY = window.scrollY;
        if (scrollY > 80) {
            header.classList.add('fixed-header');
            body.classList.add('fixed-header');
        } else {
            header.classList.remove('fixed-header');
            body.classList.remove('fixed-header');
        }
    }

    window.addEventListener('scroll', updateHeaderClass);

    updateHeaderClass();
}
